export const recommendations = {
  beginner: ["foundation-group", "binarex-assistant", "pocket-era", "otc-session-navigator", "learning-access-code"],
  manual: ["technical-indicator-lab", "binarex-assistant", "confluence-analysis-app", "evo-market-algorithm", "elite-learning-room"],
  lessManual: ["quant-research-algorithm", "nexus-vision", "mirror-study-access", "strategyx-lab", "ultra-session-scanner"],
  session: ["otc-session-navigator", "ultra-session-scanner", "pro-analysis-suite", "quant-research-algorithm", "nexus-vision"],
  mirror: ["mirror-study-access", "foundation-group", "elite-learning-room", "quant-research-algorithm"],
  personal: ["individual-learning-session", "foundation-group", "elite-learning-room", "pocket-era"],
  pro: ["strategyx-lab", "nexus-vision", "vertex-mt5-lab", "quant-research-algorithm", "individual-learning-session"],
  education: ["pocket-era", "binarex-assistant", "confluence-analysis-app", "technical-indicator-lab", "foundation-group"],
  mt5: ["vertex-mt5-lab", "individual-learning-session", "technical-indicator-lab"],
  flagship: ["nexus-vision", "strategyx-lab", "quant-research-algorithm", "evo-market-algorithm"],
};

export const selectorOptions = [
  { key: "beginner", labelKey: "selOptBeginner", resultKey: "resBeginner" },
  { key: "manual", labelKey: "selOptManual", resultKey: "resManual" },
  { key: "lessManual", labelKey: "selOptLessManual", resultKey: "resLessManual" },
  { key: "session", labelKey: "selOptSession", resultKey: "resSession" },
  { key: "mirror", labelKey: "selOptMirror", resultKey: "resMirror" },
  { key: "personal", labelKey: "selOptPersonal", resultKey: "resPersonal" },
  { key: "pro", labelKey: "selOptPro", resultKey: "resPro" },
  { key: "education", labelKey: "selOptEducation", resultKey: "resEducation" },
  { key: "mt5", labelKey: "selOptMt5", resultKey: "resPro" },
  { key: "flagship", labelKey: "selOptFlagship", resultKey: "resPro" },
];
